export const about1 = require('./about1.jpg')
export const about2 = require('./about2.jpg')
export const about3 = require('./about3.jpg')
export const about4 = require('./about4.jpg')
export const about5 = require('./about5.mp4')